module.exports = __webpack_public_path__ + "img/ar11.a5af7c3c.jpg";